import { type SortOrdering } from './types';

export const defaultSortOrdering = '-creationDate';

export function isDefaultSortOrdering(value: unknown): value is SortOrdering {
  return value === defaultSortOrdering;
}
